'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getMethodDisplayName = exports.getMethodsForCountry = undefined;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _cash = require('./methods/cash');

var _cash2 = _interopRequireDefault(_cash);

var _credit = require('./methods/credit');

var _credit2 = _interopRequireDefault(_credit);

var _com = require('./methods/com.cellarix');

var _com2 = _interopRequireDefault(_com);

var _ilCo = require('./methods/il.co.mysodexo');

var _ilCo2 = _interopRequireDefault(_ilCo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Methods
var methodsList = [_cash2.default, _credit2.default, _com2.default, _ilCo2.default];
var methods = _lodash2.default.reduce(methodsList, function (methods, method) {
    methods[method.id] = method;return methods;
}, {});

var getMethodsForCountry = exports.getMethodsForCountry = function getMethodsForCountry(countryCode) {
    return (0, _lodash2.default)(methods).filter(function (method) {
        return _lodash2.default.isUndefined(method.countries) || _lodash2.default.includes(method.countries, countryCode);
    }).map(function (method) {
        return _lodash2.default.omit(method, 'countries');
    }).value();
};

var getMethodDisplayName = exports.getMethodDisplayName = function getMethodDisplayName(i18nGet, methodId) {
    return i18nGet('method_' + methodId + '_title');
};